import { hours, contactInfo } from "@/mocks/homeData";

export default function HoursLocationSection() {
  return (
    <section id="horaires" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="text-sm font-semibold tracking-wider text-primary-500 uppercase mb-2 block">
            Où nous trouver
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-4 font-heading tracking-wide">
            Horaires et accès
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12">
          <div className="space-y-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <i className="ri-time-line w-5 h-5 flex items-center justify-center text-primary-500" />
                <h3 className="text-lg font-semibold text-white font-heading tracking-wide">
                  Horaires d'ouverture
                </h3>
              </div>
              <div className="bg-white/5 rounded-lg border border-white/10 overflow-hidden">
                <div className="hidden md:grid grid-cols-3 bg-white/5 px-4 py-3 text-sm font-semibold text-white/80">
                  <span>Jour</span>
                  <span>Matin</span>
                  <span>Après-midi</span>
                </div>
                {hours.map((h) => (
                  <div
                    key={h.day}
                    className={`grid grid-cols-3 md:grid-cols-3 px-4 py-3 text-sm border-t border-white/10 ${
                      h.isOpen
                        ? "text-white"
                        : "text-white/40"
                    }`}
                  >
                    <span className="font-medium">{h.day}</span>
                    <span>{h.morning}</span>
                    <span>{h.afternoon}</span>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <div className="flex items-center gap-2 mb-4">
                <i className="ri-map-pin-line w-5 h-5 flex items-center justify-center text-primary-500" />
                <h3 className="text-lg font-semibold text-white font-heading tracking-wide">
                  Adresse et contact
                </h3>
              </div>
              <div className="bg-white/5 rounded-lg border border-white/10 p-5 space-y-3">
                <p className="text-white/80">
                  {contactInfo.address}
                  <br />
                  {contactInfo.city}
                </p>
                <a
                  href={contactInfo.phoneHref}
                  className="flex items-center gap-2 text-primary-500 hover:text-primary-600 font-medium transition-colors"
                >
                  <i className="ri-phone-line w-4 h-4 flex items-center justify-center" />
                  {contactInfo.phone}
                </a>
                <a
                  href={contactInfo.emailHref}
                  className="flex items-center gap-2 text-primary-500 hover:text-primary-600 font-medium transition-colors"
                >
                  <i className="ri-mail-line w-4 h-4 flex items-center justify-center" />
                  {contactInfo.email}
                </a>
              </div>

              <div className="flex flex-col gap-3 mt-5 w-full">
                <a
                  href={contactInfo.phoneHref}
                  className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-md transition-colors whitespace-nowrap"
                >
                  <i className="ri-phone-line w-4 h-4 flex items-center justify-center" />
                  Appeler le garage
                </a>
                <a
                  href={contactInfo.whatsappDevisHref}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 bg-white/10 border border-white/10 hover:bg-white/20 text-white font-semibold rounded-md transition-colors whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center" />
                  Demander un devis
                </a>
                <a
                  href={`https://www.google.com/maps/dir/?api=1&destination=${contactInfo.mapsQuery}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 bg-white/10 border border-white/10 hover:bg-white/20 text-white font-semibold rounded-md transition-colors whitespace-nowrap"
                >
                  <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center" />
                  Obtenir l'itinéraire
                </a>
              </div>
            </div>
          </div>

          <div className="flex flex-col h-full">
            <div className="flex items-center gap-2 mb-4">
              <i className="ri-map-2-line w-5 h-5 flex items-center justify-center text-primary-500" />
              <h3 className="text-lg font-semibold text-white font-heading tracking-wide">
                Localisation
              </h3>
            </div>
            <div className="flex-1 min-h-[300px] md:min-h-0 rounded-lg overflow-hidden border border-white/10 bg-secondary-100">
              <iframe
                src={`https://maps.google.com/maps?q=${contactInfo.mapsQuery}&z=15&output=embed`}
                width="100%"
                height="100%"
                className="border-0 min-h-[300px] md:min-h-[500px]"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Mobicar Pro - 14 rue Georges Pompidou, Le Tampon, La Réunion"
              />
            </div>
            <a
              href={`https://www.google.com/maps/dir/?api=1&destination=${contactInfo.mapsQuery}`}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 inline-flex items-center justify-center gap-2 px-5 py-3 bg-background-100 border border-background-300 hover:bg-background-200 text-foreground-800 font-semibold rounded-md transition-colors whitespace-nowrap md:hidden"
            >
              <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center" />
              Obtenir l'itinéraire
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}